import React from 'react';
import {Trans} from 'react-i18next';
import LeftTitleWithField from '../../layout/LeftTitleWithField';
import {Field} from 'formik';
import _get from 'lodash/get';
import CustomSwitch from '../../../../../components/layout/CustomSwitch';
import Select from 'react-select';
import {deviceOptions} from '../../config/utils/optionsUtils';
import storeUtils from '../../../../../utils/storeUtils';
import ImageField from '../../../../../components/formik/ImageField';
import Section from '../../layout/Section';
import {useSelector} from 'react-redux';
import smbUtils from '../../../../../utils/smbUtils';

export default function RecommendationSettings({
  formikProps,
  imageType,
  setImageType,
}) {
  const accountSummary = useSelector(
    state => state.components.auth.accountSummary
  );
  const {customerId} = smbUtils.customerInfo(accountSummary);

  return (
    <Section
      title={
        <Trans i18nKey="p.s.uiconfiguration.skinresultpage.recommendation.settings">
          Recommendation Settings
        </Trans>
      }
    >
      <LeftTitleWithField
        title={
          <Trans i18nKey="p.s.uiconfiguration.skinresultpageultpage.show.recommendation.banner">
            Show Recommendation Banner
          </Trans>
        }
      >
        <Field
          name="skinResultPage.recommendation.showSummary"
          value={_get(formikProps.values, 'skinResultPage.recommendation.showSummary')}
          component={CustomSwitch}
        />
      </LeftTitleWithField>
      <LeftTitleWithField
        title={
          <Trans i18nKey="p.s.uiconfiguration.skinresultpageultpage.show.business.name">
            Show Brand Name on Product & Treatment Cards
          </Trans>
        }
      >
        <Field
          name="skinResultPage.recommendation.showProductCardBusinessName"
          value={_get(
            formikProps.values,
            'skinResultPage.recommendation.showProductCardBusinessName'
          )}
          component={CustomSwitch}
        />
      </LeftTitleWithField>
      <LeftTitleWithField
        title={
          <Trans i18nKey="p.s.uiconfiguration.landingpage.device">Device</Trans>
        }
      >
        <Select
          options={deviceOptions}
          onChange={o => {
            storeUtils.setUiConfigSettingDevice(customerId, _get(o, 'value'));
            setImageType(o);
          }}
          value={deviceOptions.find(o => o.value === _get(imageType, 'value'))}
          isSearchable={false}
          isClearable={false}
          placeholder={
            <Trans i18nKey="c.c.select.placeholder">Select...</Trans>
          }
        />
      </LeftTitleWithField>
      <LeftTitleWithField
        title={
          <Trans i18nKey="p.s.uiconfiguration.skinresultpage.recommendation.banner.background">
            Recommendation Banner Background Image
          </Trans>
        }
      >
        {_get(imageType, 'value') === 'mobile' && (
          <Field
            name="skinResultPage.recommendation.backgroundImage[0].imageUrl"
            imageUrl={_get(
              formikProps.values,
              'skinResultPage.recommendation.backgroundImage[0].imageUrl'
            )}
            scaleImage={true}
            clearFormFields={['skinResultPage.recommendation.backgroundImage[0].imageUrl']}
            component={ImageField}
            width={828}
            height={276}
            maxWidth={414}
            maxHeight={138}
          />
        )}
        {_get(imageType, 'value') === 'pad' && (
          <Field
            name="skinResultPage.recommendation.backgroundImage[1].imageUrl"
            imageUrl={_get(
              formikProps.values,
              'skinResultPage.recommendation.backgroundImage[1].imageUrl'
            )}
            scaleImage={true}
            clearFormFields={['skinResultPage.recommendation.backgroundImage[1].imageUrl']}
            component={ImageField}
            width={2048}
            height={512}
            maxWidth={412}
            maxHeight={103}
          />
        )}
        {_get(imageType, 'value') === 'padLandscape' && (
          <Field
            name="skinResultPage.recommendation.backgroundImage[2].imageUrl"
            imageUrl={_get(
              formikProps.values,
              'skinResultPage.recommendation.backgroundImage[2].imageUrl'
            )}
            scaleImage={true}
            clearFormFields={['skinResultPage.recommendation.backgroundImage[2].imageUrl']}
            component={ImageField}
            width={3454}
            height={568}
            maxWidth={691}
            maxHeight={114}
          />
        )}
      </LeftTitleWithField>
    </Section>
  );
}
